import React, { ComponentType } from 'react';
import ReactDOM from 'react-dom';

export type ReactCellRendererParams = {
  Component: ComponentType<any>;
};

export class ReactCellRenderer {
  eGui: HTMLElement;

  constructor() {
    this.eGui = document.createElement('span');
  }

  init(params: ReactCellRendererParams): void {
    ReactDOM.render(<params.Component {...params} />, this.eGui);
  }

  getGui(): HTMLElement {
    return this.eGui;
  }

  refresh(params: ReactCellRendererParams): boolean {
    ReactDOM.render(<params.Component {...params} />, this.eGui);
    return true;
  }

  destroy(): void {
    ReactDOM.unmountComponentAtNode(this.eGui);
  }
}
